import { useRef } from 'react';
import useClickAway from 'react-use/lib/useClickAway.js';

const useClickOutside = (callback) => {
  const ref = useRef(null);
  useClickAway(ref, callback);
  return { ref };
};

export default useClickOutside;
